<div class="yc-layout yc-layout-login justify-content-between"
  [class.flex-column]="!bbidTiedToAnotherAccount">
  <div *ngIf="!bbidTiedToAnotherAccount"></div>

  <!-- BBID tied to another account -->
  <gc-bbid-already-exists-block *ngIf="bbidTiedToAnotherAccount"
    [bbidEmail]="bbidEmail"
    [failReason]="failReason"
    [gcEmail]="email"
    [initialRoute]="initialRoute"
    (onSignInToExistingBbidAccount)="signInToExistingBbidAccount()">
  </gc-bbid-already-exists-block>

</div>